import { Directive, ElementRef } from "@angular/core";

@Directive({
  selector: "[group-item]",
})
export class GroupItemDirective {
  constructor(public element: ElementRef<any>) { }
}
